export default "__VITE_ASSET__P13bPniY__"